import { FormControl, FormControlLabel, Checkbox as MuiCheckbox, CheckboxProps  } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    checkbox: {
      color: 'var(--grayLv1)',
      marginTop: '8px',
      marginBottom: '16px',

      '& .MuiTypography-root': {
        fontSize: '1.2rem'
      },

      "@media (min-width: 1920px)": {
        marginTop: '16px',
        marginBottom: '40px',
        '& .MuiTypography-root': {
          fontSize: '1.4rem'
        }
      },
    },
    icon: {
      borderRadius: 3,
      width: 22,
      height: 22,
      boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
      backgroundColor: '#f5f8fa',
      backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
      '$root.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
      },
      'input:hover ~ &': {
        backgroundColor: '#ebf1f5',
      },
      'input:disabled ~ &': {
        boxShadow: 'none',
        background: 'rgba(206,217,224,.5)',
      },
    },
    checkedIcon: {
      backgroundColor: 'var(--grayLv1)',
      backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
      '&:before': {
        display: 'block',
        width: 22,
        height: 22,
        backgroundImage:
          "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
          " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
          "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""',
      },
      'input:hover ~ &': {
        backgroundColor: 'var(--grayLv1)',
      },
    },
}));

interface SelectFieldTypes extends CheckboxProps {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
  variant?: 'outlined' | 'filled' | 'standard',
  id?: string,
  name?: string,
  label?: string,
  checked?: boolean,
}

export const Checkbox = ({
  checked,
  className,
  onChange,
  variant = 'outlined',
  id,
  name,
  label }: SelectFieldTypes) => {
  const classes = useStyles();
  
  return (
    <FormControl variant={variant} fullWidth>
      <FormControlLabel
        className={className ? className: classes.checkbox}
        control={
          <MuiCheckbox
            size="medium"
            checked={checked}
            onChange={onChange}
            name={name}
            id={id}
            color="primary"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
          />
        }
        label={label}
      />
    </FormControl>
  )
}